export default {
  payments: {
    adyen: {
      imgPath: 'https://checkoutshopper-test.adyen.com/checkoutshopper/images/logos/{{type}}.svg',
      pos: {
        urls: {
          host: `${process.env.VUE_APP_MAGENTO}/adyen`,
          connection: '/connectedTerminals',
          sync: '/sync'
        },
        merchant: 'CoinSrlPOS',
        key: 'AQEphmfxKorNbx1Lw0m/n3Q5qf3Va4REA6BYVHQMsYyofFQ1m4/h8DdO5rgQwV1bDb7kfNy1WIxIIkxgBw==-V+QMrkC97DkngSloF4DjjCpvakfWunz5jB6NZpoRCQQ=-I&RW#6=m4zQ8D{3+'
      }
    },
    payByLink: {
      link: {
        urls: {
          host: `${process.env.VUE_APP_MAGENTO}/adyen/payByLink`
        },
        merchant: 'CoinSrlIT'
      }
    }
  }
}
